__webpack_require__.p = "/Pokedex/";